import { PeopleSummaryData } from 'api/gql-utils/employeeOnboardingGql/types';
import { PeopleTabValue, VisiblePeopleTabValue } from '../types';

export const activePeopleApiParamsMap: Partial<Record<PeopleTabValue, boolean>> = {
  active: true,
  employees: true,
  contractors: true,
  dismissed: false,
};

export const employeeTypePeopleApiParamsMap: Partial<Record<PeopleTabValue, string>> = {
  employees: 'employee',
  contractors: 'contractor',
};

export const getPeopleTableHeading = (
  contractorsTitleCase: string,
): Record<PeopleTabValue, string> => {
  return {
    active: 'Active Users',
    employees: 'Active Employees',
    contractors: `Active ${contractorsTitleCase}`,
    drafts: 'Draft Employees',
    dismissed: 'Dismissed Employees',
    search: 'Search Results',
  };
};

export const getPeopleTabs = (
  contractorsTitleCase: string,
): Array<{
  label: string;
  value: VisiblePeopleTabValue;
  key: keyof PeopleSummaryData;
}> => {
  return [
    {
      label: 'Active',
      value: 'active',
      key: 'activeUsers',
    },
    {
      label: 'Employees',
      value: 'employees',
      key: 'activeEmployees',
    },
    {
      label: contractorsTitleCase,
      value: 'contractors',
      key: 'activeContractors',
    },
    {
      label: 'Drafts',
      value: 'drafts',
      key: 'draftEmployees',
    },
    {
      label: 'Dismissed',
      value: 'dismissed',
      key: 'dismissed',
    },
  ];
};
